/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import UpDownButtons from "components/position-buttons/up-down-buttons";
import { Logger } from "cms/utils/log/logger";

const PositionButtons = (props) => {
    
    const { index, list = [], handleUpdate } = props;

    const [position, setPosition] = useState(index);
    const [count, setCount] = useState(index);
    const [isFirst, setIsFirst] = useState(index);
    const [isLast, setIsLast] = useState(index);

    const last_index = count - 1;
    const isSingle = count === 1;

    useEffect(() => {
        setPosition(index);
        const _isFirst = index === 0 && !isSingle;
        setIsFirst(_isFirst);
        const _isLast = index === last_index && !isSingle;
        setIsLast(_isLast);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [index]);

    useEffect(() => {
        setCount(list?.length || 0);
    }, [list]);

    const changePosition = (e, direction, position) => {
        Logger.debug(`changePosition ${direction} ${position} `);
        const last_pos = count - 1;
        const isLast = position === last_pos;
        const isFirst = position === 0;
        let target_position;

        if (isFirst) {
            target_position = direction === "up" ? 0 : position + 1;
        } else if (isLast) {
            target_position = direction === "down" ? last_pos : position - 1;
        } else {
            target_position = direction === "up" ? position - 1 : position + 1;
        }
        const params = { position, direction, target_position };
        changePositions(params);
        // Logger.flush()
    };

    const changePositions = (params) => {
        Logger.debug("changePosition");
        const { position, direction, target_position } = params;
        Logger.debug(`change position: ${direction}, ${position} ${target_position}`);
        const pos_components = [...list];
        // remove item in array
        const [moving_section] = pos_components.splice(position, 1);
        // add item in new location
        pos_components.splice(target_position, 0, moving_section);
        for (let i = 0; i < pos_components.length; i++) {
            const section = pos_components[i];
            section.position = i;
        }
        handleUpdate(pos_components);
    };

    const moveUp = (event) => {
        event.stopPropagation();
        changePosition(event, "up", position);
    };

    const moveDown = (event) => {
        event.stopPropagation();
        changePosition(event, "down", position);
    };
    const noMove = (event) => {
        event.stopPropagation();
    };

    const defaultProps = {
        handleUp: moveUp,
        handleDown: moveDown,
    };

    let activeProps;
    if (isFirst) {
        activeProps = { ...defaultProps, handleUp: noMove, upDisabled: true };
    } else if (isLast) {
        activeProps = { ...defaultProps, handleDown: noMove, downDisabled: true };
    } else {
        activeProps = defaultProps;
    }

    return <UpDownButtons {...activeProps} />;
};

export default PositionButtons;
